import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectCompanyIpWhitelistEntries = createSelector(
  getCompany,
  ({ companyIpWhitelist }) => companyIpWhitelist,
);
